import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClaimIncentivePage } from './claim-incentive.page';

const routes: Routes = [
  {
    path: '',
    component: ClaimIncentivePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClaimIncentivePageRoutingModule {}
